import { useState, useRef, useEffect } from "react"
import styles from "./BillSubMenu.module.scss"
import { CountrySelectorIcon } from "../../../assets/icons"
import { SubMenuInteraction } from "../../menu.types";
import { useLocation, useNavigate } from "react-router-dom";
import { useConfigLayout } from "../../../hooks/useConfigLayout";

interface BillSubMenuProps {
    menu: SubMenuInteraction;
}

const BillSubMenu = ({ menu}: Readonly<BillSubMenuProps>) => {
  const [isCollapsed, setIsCollapsed] = useState(false)
  const [containerWidth, setContainerWidth] = useState<number>(0)
  const containerRef = useRef<HTMLDivElement>(null);

 const { updateLayout} = useConfigLayout();

useEffect(() => {
    updateLayout({
      showCountrySelector: false,
      utility: null,
      showExportButton: false,
      showBreadCrumb: false,
    });
  }, []);

  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;


  const { mainMenuName, subMenuItems } = menu;
  
  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth)
    }
  }, [])

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed)
  }
 
  const handleSubMenuClick = (submenuItem: any) => {
    navigate(submenuItem.route);
  };

  const isSubMenuActive = (route: string) => {
    return currentPath === route;
  };


  return (
    <div className={styles.container}>
      <div
        className={`${styles.subMenuSelectorWrapper} ${isCollapsed ? styles.collapsed : ""}`}
        style={{
          width: isCollapsed ? "0" : "240px",
        }}
      >
        <div ref={containerRef} className={styles.subMenuSelector}>
          <div className={styles.header}>
            <h3 className={styles.title}>{mainMenuName}</h3>
          </div>

          <div className={styles.subMenuList}>
            {subMenuItems.length > 0 && subMenuItems.map((submenu) => (
              <button
                key={submenu.text}
                className={`${styles.subMenuItem} ${isSubMenuActive(submenu.route) ? styles.selected : ""}`}
                onClick={() => handleSubMenuClick(submenu)}
              >
                {isSubMenuActive(submenu.route) ? submenu.isActiveIcon : submenu.icon}
                <span className={styles.subMenuName}>{submenu.text}</span>
              </button>
            ))}
          </div>
        </div>
      </div>

      <button
        onClick={toggleCollapse}
        className={`${styles.toggleButton} ${isCollapsed ? styles.collapsed : ""}`}
        aria-label={isCollapsed ? "Expand sub-menu" : "Collapse submenu"}
      >
        <CountrySelectorIcon className={isCollapsed ? styles.rotated : ""} />
      </button>
    </div>
  )
}

export default BillSubMenu;
